<template>
  <main>
    <div
      id="app"
      :data-locale="formattedLocale"
      @open-quickshop="DialogQuickshop.open({ product: $event.detail, gtmConfig: { appSource: 'backpack-finder' } })"
    />
    <dialog-quickshop :size="{ sm: 'full', lg: 'lg' }" :type="{ sm: 'panel', lg: 'modal' }" />
  </main>
</template>

<script lang="ts" setup>
const { configExternalApps: { backpackFinderUrl = '' } } = useFeatureFlags()
const formattedLocale = useFormattedLocale()

useScriptTag(
  backpackFinderUrl,
  undefined,
  {
    attrs: {
      fetchpriority: 'high'
    }
  }
)

useHead({
  bodyAttrs: {
    class: 'hide-chat-button'
  }
})

const DialogQuickshop = createDialog('quickshop')

onMounted(() => setInteractionOrigin('backpack-finder'))
</script>
